var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pdf"}},[_c('span',{staticClass:"back",on:{"click":_vm.goBack}},[_c('van-icon',{attrs:{"name":"arrow-left"}})],1),_c('div',{attrs:{"id":"demo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }